import { render } from "./Kode_AI_Button.vue?vue&type=template&id=56426bff&scoped=true"
import script from "./Kode_AI_Button.vue?vue&type=script&lang=js"
export * from "./Kode_AI_Button.vue?vue&type=script&lang=js"

import "./Kode_AI_Button.vue?vue&type=style&index=0&id=56426bff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56426bff"]])

export default __exports__